import * as React from "react";
const Membership = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="Membership"
      width={20}
      height={20}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M6 6h20v20H6z" />
    </mask>
    <g mask="url(#Membership)">
      <path
        fill="#EAF2FF"
        d="M9.334 24.333c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176V13.5c0-.458.163-.85.49-1.177.326-.327.718-.49 1.177-.49H13.5v-2.5c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49h1.667c.458 0 .85.164 1.177.49.326.327.49.719.49 1.177v2.5h4.166c.458 0 .85.163 1.177.49.326.326.49.719.49 1.177v9.167c0 .458-.163.85-.49 1.177-.326.326-.719.49-1.177.49H9.334Zm0-1.666h13.333V13.5H18.5c0 .458-.163.85-.49 1.177-.326.326-.718.49-1.176.49h-1.667c-.458 0-.85-.164-1.177-.49a1.605 1.605 0 0 1-.49-1.177H9.334v9.167ZM11 21h5v-.375c0-.236-.066-.455-.198-.656a1.308 1.308 0 0 0-.552-.469 4.3 4.3 0 0 0-.843-.281 4.219 4.219 0 0 0-.907-.094c-.32 0-.621.031-.906.094a4.3 4.3 0 0 0-.844.281c-.236.111-.42.267-.552.469-.132.201-.198.42-.198.656V21Zm6.667-1.25H21V18.5h-3.333v1.25ZM13.5 18.5c.348 0 .643-.122.886-.365s.364-.538.364-.885-.121-.642-.364-.886A1.206 1.206 0 0 0 13.5 16c-.347 0-.642.122-.885.364a1.206 1.206 0 0 0-.365.886c0 .347.122.642.365.885s.538.365.885.365Zm4.167-1.25H21V16h-3.333v1.25Zm-2.5-3.75h1.667V9.333h-1.667V13.5Z"
      />
    </g>
  </svg>
);
export default Membership;
